// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { SelectField } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { messages } from '../../../i18n/messages';

const FilterSortBarContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  padding-bottom: 32px;
`;

const SelectStyled = styled(SelectField)`
  padding: 0;
  min-width: unset;

  label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  div {
    margin: 0;
  }
`;

export const FilterSortBar = () => {
  const { reviewStarFilter, reviewSort } = mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();
  const onChangeStarFilter = (event: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch({ type: ActionTypes.setReviewStarFilter, payload: event.target.value });
    dispatch({ type: ActionTypes.setReviewSort, payload: 'Newest' });
  };
  const onChangeSort = (event: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch({ type: ActionTypes.setReviewSort, payload: event.target.value });
  };
  const filterByLabel = useI18n(messages.five_star_filter_by);
  const allStarsLabel = useI18n(messages.five_star_all_stars);
  const singleStarLabel = useI18n(messages.five_star_single_star);
  const pluralStarLabel = useI18n(messages.five_star_plural_star);
  const sortByLabel = useI18n(messages.five_star_sort_by);
  const newestLabel = useI18n(messages.five_star_newest);
  const oldestLabel = useI18n(messages.five_star_oldest);
  const highestLabel = useI18n(messages.five_star_highest);
  const lowestLabel = useI18n(messages.five_star_lowest);
  return (
    <FilterSortBarContainer>
      <SelectStyled
        required
        id="filter-by-stars"
        label={`${filterByLabel}:`}
        onChange={onChangeStarFilter}
        value={reviewStarFilter}
      >
        <option value="All stars">{allStarsLabel}</option>
        <option value="1 star">1 {singleStarLabel}</option>
        <option value="2 star">2 {pluralStarLabel}</option>
        <option value="3 star">3 {pluralStarLabel}</option>
        <option value="4 star">4 {pluralStarLabel}</option>
        <option value="5 star">5 {pluralStarLabel}</option>
      </SelectStyled>
      <SelectStyled
        required
        id="sort-by"
        label={`${sortByLabel}:`}
        onChange={onChangeSort}
        value={reviewSort}
      >
        <option value="Newest">{newestLabel}</option>
        <option value="Oldest">{oldestLabel}</option>
        {reviewStarFilter === 'All stars' && (
          <>
            <option value="Highest">{highestLabel}</option>
            <option value="Lowest">{lowestLabel}</option>
          </>
        )}
      </SelectStyled>
    </FilterSortBarContainer>
  );
};
